import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";
import { PaginationMeta } from "./doctor";

export interface FirmServerFilters {
    head_quarter_id?: number;
    location_id?: number;
    city?: string;
    search?: string;
}

export const getAllFirms = async (
    tenant_id: number,
    page: number = 1,
    per_page: number = 15,
    filters?: FirmServerFilters
): Promise<{ data: any[]; pagination: PaginationMeta }> => {
    const response = await api.get(`${API_ROUTES.FIRM}/list/${tenant_id}`, {
        params: { page, per_page, ...filters },
    });
    return {
        data: response.data.data,
        pagination: response.data.pagination,
    };
}

export const addNewFirm = async (data: any) => {
    const response = await api.post(
        API_ROUTES.FIRM,
        data
    );
    return response;
};

export const deleteFirm = async (firmID: number) => {
    const response = await api.delete(`${API_ROUTES.FIRM}/${firmID}`);
    return response;
}

export const editFirm = async (firmID: number, edits: any) => {
    const response = await api.put(`${API_ROUTES.FIRM}/${firmID}`, edits)
    return response;
}
